import { SyntheticEvent } from "react";
import { Icon } from "../Icon";

import styles from "./Chips.module.css";

export interface IChips {
  id: string | number;
  label: string;
}

export interface ChipsProps {
  item: IChips;
  width?: number | string;
  onRemove(arg: IChips, arg1: SyntheticEvent): void;
}

export default function Chips({ item, width, onRemove }: Readonly<ChipsProps>) {
  return (
    <div className={styles.chipsContainer} style={{ width }}>
      <div className={styles.text}>{item.label}</div>
      <span
        role="button"
        tabIndex={0}
        className={styles.imageWrapper}
        onClick={(e) => onRemove(item, e)}
        onKeyDown={(e) => {
          if (e.code === "Enter") {
            onRemove(item, e);
          }
        }}
        aria-label="Delete"
      >
        <Icon hoverEffect name="x" color="Grey-400" size={16} />
      </span>
    </div>
  );
}
